export const payroll = [
    {
        id: "P738197",
        name: "Kevin",
        department: "Admin",
        designation: "Technical Head",
        phone: "+1 63423 72397",
        amount: "$15,000",
        status: "Paid",
        details: "View Payslip",
    },
      {
        id: "P738197",
        name: "Willie",
        department: "Management",
        designation: "Receptionist",
        phone: "+1 82913 61371",
        amount: "$12,000",
        status: "Generated",
        details: "View Details",
    },
      {
        id: "P738196",
        name: "Daniel",
        department: "Management",
        designation: "Admin",
        phone: "+1 56752 86742",
        amount: "$13,000",
        status: "Paid",
        details: "View Payslip"
    },
      {
        id: "P738195",
        name: "Teresa",
        department: "Management",
        designation: "Admin",
        phone: "+1 82392 37359",
        amount: "$13,000",
        status: "Paid",
        details: "View Payslip"
    },
      {
        id: "P738194",
        name: "Johnson",
        department: "Finance",
        designation: "Accountant",
        phone: "+1 53619 54691",
        amount: "$18,000",
        status: "Paid",
        details: "View Payslip"
    },
      {
        id: "P738193",
        name: "Hellana",
        department: "Management",
        designation: "HR Manager",
        phone: "+1 23566 52683",
        amount: "$12,000",
        status: "Generated",
        details: "View Details"
    },
      {
        id: "P738192",
        name: "James",
        department: "Library",
        designation: "Librarian",
        phone: "+1 78429 82414",
        amount: "$10,000",
        status: "Paid",
        details: "View Payslip"
    },
      {
        id: "P738191",
        name: "Jacquelin",
        department: "Transport",
        designation: "Driver",
        phone: "+1 77502 54845",
        amount: "$8000",
        status: "Paid",
        details: "View Payslip"
    },
      {
        id: "P738190",
        name: "Edward",
        department: "Finance",
        designation: "Accounts Manager",
        phone: "+1 56187 87489",
        amount: "$12,000",
        status: "Paid",
        details: "View Details"
    },
      {
        id: "P738189",
        name: "Elizabeth",
        department: "Management",
        designation: "Receptionist",
        phone: "+1 97846 84518",
        amount: "$10,000",
        status: "Paid",
        details: "View Details"
    }
]
